import { buildExcelPromptPayload } from "./excelPromptData";
import { buildOutputContract } from "./promptBase";

const buildJsonSection = (title, payload) => `## ${title}
\`\`\`json
${JSON.stringify(payload, null, 2)}
\`\`\``;

const hasValues = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === "object") return Object.keys(value).length > 0;
  return value !== null && value !== undefined && value !== "";
};

export const buildAnalysisPrompt = ({
  customerContext,
  excelData,
  filters,
  normalizedFinancialData,
  reportContext,
  language,
}) => {
  const excelPayload = buildExcelPromptPayload(excelData);
  const sections = [
    buildJsonSection("REPORT CONTEXT", reportContext || {}),
    buildJsonSection("FILTERS", filters || {}),
    hasValues(customerContext) ? buildJsonSection("CUSTOMER CONTEXT", customerContext) : "",
    excelPayload ? buildJsonSection("EXCEL DATA", excelPayload) : "",
    buildJsonSection("FINANCIAL DATA", normalizedFinancialData || {}),
    buildOutputContract(language),
  ];

  return sections.filter(Boolean).join("\n\n");
};
